import React, { useEffect, useRef } from "react";

function GoogleMap({ lat, lng, zoom }) {
  const mapRef = useRef(null);

  useEffect(() => {
    const INFO_WIDTH = 400;     // target width in px
    const LOGO_MAX = 220;       // max logo width in px

    const initMap = () => {
      const map = new window.google.maps.Map(mapRef.current, {
        center: { lat, lng },
        zoom,
      });

      const marker = new window.google.maps.Marker({
        position: { lat, lng },
        map,
        title: "Business Location",
      });

      const content = `
        <!-- Cancel Google’s default padding, then use our own -->
        <div style="margin:-12px; padding:0;">
          <div
            style="
              box-sizing:border-box;
              padding:12px 14px 14px;
              color:#111;
              width:min(${INFO_WIDTH}px, 90vw);
              max-width:${INFO_WIDTH}px;
            "
          >
            <img
              src="https://cipa-website-assets.s3.us-east-2.amazonaws.com/site-photos/CIPAheaderlogo.png"
              alt="Central Illinois Pediatric Associates"
              style="
                display:block;
                max-width:${LOGO_MAX}px;
                width:100%;
                height:auto;
                margin:0 auto 10px;
                border:0;
              "
            />

            <h2 style="font-size:20px; font-weight:700; margin:0 0 8px;">
              Central Illinois Pediatric Associates
            </h2>
            <p style="font-size:15px; margin:0 0 6px;">
              2427 Maloney Dr., Bloomington, IL 61704
            </p>
            <p style="font-size:15px; margin:0 0 12px;">
              Phone: <a href="tel:+13096631011" style="color:#2563eb; text-decoration:none;">
                (309) 663-1011
              </a>
            </p>

            <div style="display:flex; gap:8px;">
              <button
                onclick="window.open('https://www.google.com/maps/dir/?api=1&destination=Central%20Illinois%20Pediatric%20Associates', '_blank')"
                style="
                  flex:1;
                  padding:10px 12px;
                  background:#2563eb;
                  color:#fff;
                  font-size:14px;
                  font-weight:600;
                  border:none;
                  border-radius:8px;
                  cursor:pointer;
                "
              >
                Get Directions
              </button>
            </div>
          </div>
        </div>
      `;

      const infoWindow = new window.google.maps.InfoWindow({
        content,
        maxWidth: INFO_WIDTH,                // allow the wider layout
        pixelOffset: new window.google.maps.Size(0, -6),
      });

      infoWindow.open(map, marker);
      marker.addListener("click", () => infoWindow.open(map, marker));
    };

    const loadGoogleMapScript = () => {
      if (window.google && window.google.maps) {
        initMap();
        return;
      }
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&callback=initMap`;
      script.async = true;
      script.defer = true;
      window.initMap = initMap;
      document.body.appendChild(script);
    };

    loadGoogleMapScript();

    return () => {
      const scripts = document.querySelectorAll('script[src*="maps.googleapis"]');
      scripts.forEach((s) => s.remove());
      delete window.initMap;
    };
  }, [lat, lng, zoom]);

  return (
    <div className="relative rounded-xl overflow-hidden">
      <div className="aspect-[16/9] lg:aspect-[16/6]">
        <div ref={mapRef} className="absolute inset-0" />
      </div>
    </div>
  );
  
}

export default GoogleMap;
